import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';
import {PreviewWindowService} from "./preview-window.service";

export default angular.module('slViz.previewWindowModule', [
    angularUiBootstrap
])
    .service('PreviewWindowService', PreviewWindowService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/preview-window/index.js